/**
 * Title parsing helpers shared by the M3U and Xtream normalizers.
 *
 * Both provider shapes put the release year in the display name rather than a
 * structured field — "Truly Naked - 2026", "SilverHawks (1986)" — so the year
 * has to be recovered from the title. Xtream panels advertise a `year` field
 * but real ones frequently omit it (the reference provider returns it for 0 of
 * 43,006 VOD items), which is why this is a fallback both paths need rather
 * than an M3U-only concern.
 */
/** Upper bound for a plausible release year. Catalogs list upcoming titles, so
 * allow a little headroom, but reject a far-future number that is really part
 * of the title ("Blade Runner 2049", "Death Race 2050"). */
function plausible(year) {
    return year <= new Date().getFullYear() + 2;
}
/**
 * Release year from a title, or undefined when there is none.
 *
 * Providers append the year as a SUFFIX — "Truly Naked - 2026",
 * "SilverHawks (1986)" — while the title itself may contain a year-like
 * number: "2073 - 2024", "Death Race 2050 - 2017", "I guerrieri dell'anno
 * 2072 - 1984". Scanning for the first match therefore picks the wrong number
 * and sorts those titles to the top of a "newest year" list, so the trailing
 * token wins and a bare scan is only the fallback.
 */
export function extractYear(title) {
    const trimmed = title.trim();
    const trailing = trimmed.match(/[([\-–—\s]\s*((?:19|20)\d{2})\s*[)\]]?\s*$/);
    if (trailing?.[1]) {
        const year = Number(trailing[1]);
        if (plausible(year))
            return year;
    }
    // No usable suffix: take the LAST year-like token, still likelier to be the
    // release year than the first when the title embeds a number.
    const all = trimmed.match(/\b(?:19|20)\d{2}\b/g);
    if (!all?.length)
        return undefined;
    for (let i = all.length - 1; i >= 0; i -= 1) {
        const year = Number(all[i]);
        if (plausible(year))
            return year;
    }
    return undefined;
}
//# sourceMappingURL=title.js.map